import React, { createContext, useContext, useState, useEffect } from 'react';

const TeacherAuthContext = createContext();

// export function TeacherAuthProvider({ children }) {
//   const [teacherData, setTeacherData] = useState(null);

//   useEffect(() => {
//     // Check localStorage for existing session on initial load
//     const storedData = localStorage.getItem('teacherData');
//     if (storedData) {
//       setTeacherData(JSON.parse(storedData));
//     }
//   }, []);

//   const login = (data) => {
//     localStorage.setItem('teacherData', JSON.stringify(data));
//     setTeacherData(data);
//   };

//   const logout = () => {
//     localStorage.removeItem('teacherData');
//     setTeacherData(null);
//   };

//   return (
//     <TeacherAuthContext.Provider value={{ teacherData, login, logout }}>
//       {children}
//     </TeacherAuthContext.Provider>
//   );
// }

// export function useTeacherAuth() {
//   return useContext(TeacherAuthContext);
// }

export function TeacherAuthProvider({ children }) {
  const [teacherData, setTeacherData] = useState(null);
  const [navigationState, setNavigationState] = useState({});

  useEffect(() => {
    const storedData = localStorage.getItem('teacherData');
    if (storedData) {
      setTeacherData(JSON.parse(storedData));
    }
  }, []);

  const login = (data) => {
    localStorage.setItem('teacherData', JSON.stringify(data));
    setTeacherData(data);
    // Initialize navigation state with schoolId
    setNavigationState({ schoolId: data.schoolId });
  };

  const logout = () => {
    localStorage.removeItem('teacherData');
    setTeacherData(null);
    setNavigationState({});
  };

  const updateNavigationState = (newState) => {
    setNavigationState((prev) => ({ ...prev, ...newState }));
  };

  return (
    <TeacherAuthContext.Provider
      value={{ teacherData, login, logout, navigationState, updateNavigationState }}
    >
      {children}
    </TeacherAuthContext.Provider>
  );
}

export function useTeacherAuth() {
  return useContext(TeacherAuthContext);
}